const API_KEYS = {
  LUNA_PRICE: "api/lunaPrice",
  STAKING_GET_USER_INFO: "staking/getUserInfo",
  STAKING_GET_UNDELEGATION_RECORDS: "staking/getUndelegationRecords",
  STAKING_GET_UNDELEGATION_BATCH_INFO: (batchId: number) =>
    "staking/getUndelegationBatchInfo/" + batchId,
};

export default API_KEYS;
